document.addEventListener("DOMContentLoaded", () => {
  function openModal(modal) {
    modal.classList.remove("hidden");
    requestAnimationFrame(() => {
      modal.classList.add("show");
    });
  }

  function closeModal(modal) {
    modal.classList.remove("show");
    setTimeout(() => {
      modal.classList.add("hidden");
    }, 300); // match CSS transition duration
  }

  let previousProductModal = null;

  // Open rewards modal from subscription perks button
  document.addEventListener("click", function (e) {
    if (  e.target.classList.contains("subscription_perks") ||
  e.target.classList.contains("subscription_perks_new")) {
      e.preventDefault();

      const productModal = e.target.closest(".product-modal");
      if (productModal) {
        // On collection (quick-buy modal)
        closeModal(productModal);
        previousProductModal = productModal;
      } else {
        // On product page, no modal involved
        previousProductModal = null;
      }

      openModal(document.getElementById("rewards-modal"));
    }
  });

  // Close rewards modal on close button
  document.getElementById("close-rewards-modal").addEventListener("click", () => {
    closeModal(document.getElementById("rewards-modal"));

    if (previousProductModal) {
      setTimeout(() => {
        openModal(previousProductModal);
        previousProductModal = null;
      }, 250);
    }
  });

  // ✅ FIXED: this block was missing its closing brace!
  document.getElementById("rewards-modal").addEventListener("click", (e) => {
    if (e.target.id === "rewards-modal") {
      closeModal(document.getElementById("rewards-modal"));

      if (previousProductModal) {
        setTimeout(() => {
          openModal(previousProductModal);
          previousProductModal = null;
        }, 250);
      }
    }
  });
});
